import { render, staticRenderFns } from "./ProfileIntelligence.vue?vue&type=template&id=7510d23d&"
import script from "./ProfileIntelligence.vue?vue&type=script&lang=js&"
export * from "./ProfileIntelligence.vue?vue&type=script&lang=js&"
import style0 from "./ProfileIntelligence.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports